export const CONFIG_REQUEST = "CONFIG_REQUEST";
export const CONFIG_FAILURE = "CONFIG_FAILURE";

export const USER_GET_COUNTRY_SUCCESS = "USER_GET_COUNTRY_SUCCESS";
export const USER_GET_CATEGORY_SUCCESS = "USER_GET_CATEGORY_SUCCESS";
export const USER_GET_NOTE_TYPE_SUCCESS = "USER_GET_NOTE_TYPE_SUCCESS";

export const ADMIN_GET_CONFIG_SUCCESS = "ADMIN_GET_CONFIG_SUCCESS";
export const ADMIN_UPDATE_CONFIG_SUCCESS = "ADMIN_UPDATE_CONFIG_SUCCESS";

export const ADMIN_CREATE_ADMIN_SUCCESS = "ADMIN_CREATE_ADMIN_SUCCESS";
export const ADMIN_UPDATE_ADMIN_SUCCESS = "ADMIN_UPDATE_ADMIN_SUCCESS";
export const ADMIN_DELETE_ADMIN_SUCCESS = "ADMIN_DELETE_ADMIN_SUCCESS";
export const ADMIN_GET_ADMIN_SUCCESS = "ADMIN_GET_ADMIN_SUCCESS";
export const ADMIN_GET_ADMINS_SUCCESS = "ADMIN_GET_ADMINS_SUCCESS";

export const ADMIN_CREATE_CATEGORY_SUCCESS = "ADMIN_CREATE_CATEGORY_SUCCESS";
export const ADMIN_UPDATE_CATEGORY_SUCCESS = "ADMIN_UPDATE_CATEGORY_SUCCESS";
export const ADMIN_DELETE_CATEGORY_SUCCESS = "ADMIN_DELETE_CATEGORY_SUCCESS";
export const ADMIN_GET_CATEGORY_SUCCESS = "ADMIN_GET_CATEGORY_SUCCESS";
export const ADMIN_GET_CATEGORIES_SUCCESS = "ADMIN_GET_CATEGORIES_SUCCESS";

export const ADMIN_CREATE_TYPE_SUCCESS = "ADMIN_CREATE_TYPE_SUCCESS";
export const ADMIN_UPDATE_TYPE_SUCCESS = "ADMIN_UPDATE_TYPE_SUCCESS";
export const ADMIN_DELETE_TYPE_SUCCESS = "ADMIN_DELETE_TYPE_SUCCESS";
export const ADMIN_GET_TYPE_SUCCESS = "ADMIN_GET_TYPE_SUCCESS";
export const ADMIN_GET_TYPES_SUCCESS = "ADMIN_GET_TYPES_SUCCESS";

export const ADMIN_CREATE_COUNTRY_SUCCESS = "ADMIN_CREATE_COUNTRY_SUCCESS";
export const ADMIN_UPDATE_COUNTRY_SUCCESS = "ADMIN_UPDATE_COUNTRY_SUCCESS";
export const ADMIN_DELETE_COUNTRY_SUCCESS = "ADMIN_DELETE_COUNTRY_SUCCESS";
export const ADMIN_GET_COUNTRY_SUCCESS = "ADMIN_GET_COUNTRY_SUCCESS";
export const ADMIN_GET_COUNTRIES_SUCCESS = "ADMIN_GET_COUNTRIES_SUCCESS";
